import { CepSteps, CepGroups } from 'basics/enums/cep.enums';

export const configurationStepFields = {
  biogenFunction: `${CepSteps.configurationStep}.${CepGroups.configuration}.biogenFunction`,
  ciDateEnd: `${CepSteps.configurationStep}.${CepGroups.configuration}.ciDateEnd`,
  ciDateStart: `${CepSteps.configurationStep}.${CepGroups.configuration}.ciDateStart`,
  customerInitiative: `${CepSteps.configurationStep}.${CepGroups.configuration}.customerInitiative`,
  date: `${CepSteps.configurationStep}.${CepGroups.configuration}.date`,
  keyMessages: `${CepSteps.configurationStep}.${CepGroups.configuration}.keyMessages`,
  kpi: `${CepSteps.configurationStep}.${CepGroups.configuration}.kpi`,
  product: `${CepSteps.configurationStep}.${CepGroups.configuration}.product`,
  therapeuticArea: `${CepSteps.configurationStep}.${CepGroups.configuration}.therapeuticArea`,
  title: `${CepSteps.configurationStep}.${CepGroups.configuration}.title`,
};

